import { useMemo } from "react";
import useUserLayoutPreferences from "./useUserLayoutPreferences";
const useTableLayout = ({
  entityTableId,
  defaultSort,
  defaultPageSize
}) => {
  const { data: userLayoutPreferences = {}, isInitialLoading } = useUserLayoutPreferences(entityTableId);
  return useMemo(
    () => {
      var _a, _b;
      return {
        layoutConfig: {
          attributes: userLayoutPreferences == null ? void 0 : userLayoutPreferences.attributes,
          order: userLayoutPreferences.order,
          pageSize: (_a = userLayoutPreferences.perPage) != null ? _a : defaultPageSize,
          sort: (_b = userLayoutPreferences.sort) != null ? _b : defaultSort
        },
        isInitialLoading
      };
    },
    [
      defaultPageSize,
      defaultSort,
      isInitialLoading,
      userLayoutPreferences == null ? void 0 : userLayoutPreferences.attributes,
      userLayoutPreferences.order,
      userLayoutPreferences.perPage,
      userLayoutPreferences.sort
    ]
  );
};
export default useTableLayout;
